import { INSIDE_APP } from '../config';
import { authTokenLoad, authTokenSave } from '../tauri/commands';

const TOKEN_KEY = 'viewer.auth';

let current: string | null = null;

/** Token em memória, usado pelo cliente da API. Carregado uma vez no início. */
export function authToken(): string | null {
  return current;
}

export async function loadAuthToken(): Promise<string | null> {
  current = INSIDE_APP ? await authTokenLoad() : localStorage.getItem(TOKEN_KEY);
  return current;
}

/** No app o token fica no cofre do Windows; no navegador, no localStorage deste site. */
export async function saveAuthToken(token: string | null): Promise<void> {
  current = token;
  if (INSIDE_APP) return authTokenSave(token);
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
